/**
 * API keys
 */
export const API_HOST_TOKEN = process.env.REACT_APP_API_HOST_TOKEN

/**
 * Environment
 */
export const API_HOST = process.env.REACT_APP_API_HOST
export const AWS_BUCKET = process.env.REACT_APP_AWS_BUCKET

/**
 * MQTT
 */
export const MQTT_HOST = process.env.REACT_APP_MQTT_HOST
export const MQTT_PORT = process.env.REACT_APP_MQTT_PORT
export const MQTT_PROTOCOL = process.env.REACT_APP_MQTT_PROTOCOL
export const MQTT_USER = process.env.REACT_APP_MQTT_USER
export const MQTT_PASSWORD = process.env.REACT_APP_MQTT_PASSWORD
export const MQTT_TOPIC = process.env.REACT_APP_MQTT_TOPIC

/**
 * CONTENT TYPES
 */
export const ATHLETIC_TEAMS = 'athletic-teams'
export const BIOS = 'bios'
export const DASHBOARD = 'dashboard'
export const EVENTS = 'full-schedule'
export const FEATURED_VIDEOS = 'featured-videos'
export const GENERAL_CONTENTS = 'general-contents'
export const GENERAL_EVENTS = 'general-events'
export const QUOTES = 'quotes'
export const SPORT_EVENTS = 'sport-events'
export const FEATURED = 'featured'
export const POSTERS = 'posters'
export const CUSTOM_CONTENTS = 'custom-contents'

/**
 * BRANDS
 */
export const BRAND = {
  ATH: 'Athletics',
  GCAD: 'GCAD',
}
